<div *ngIf="(statement$ | async) === null">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="statement$ | async as statement" class="flex flex-col lg:flex-row printable">
  <div class="flex-1 lg:px-2">
    <div
      *ngFor="let order of statement.orders; trackBy: 'id' | trackByKey"
      class="border-b border-gray-400 last:border-b-0 py-2 my-2"
    >
      <div class="flex">
        <div class="mr-1 lg:w-25">
          <div>Load ID</div>
          <div class="font-bold text-xl text-gray-800">
            {{ order.id }}
          </div>
        </div>
        <div class="flex-1">
          <div>Driver</div>
          <div class="font-bold text-xl text-gray-800">
            {{ order.driverName }}
          </div>
        </div>
      </div>
      <div class="flex flex-col print-flex-row lg:flex-row lg:px-4">
        <div class="flex-1 flex lg:items-center mb-1 lg:mb-0 no-print">
          <div>
            <lohi-settlement-order-map [order]="order"></lohi-settlement-order-map>
          </div>
        </div>
        <div class="flex-1 flex flex-col lg:justify-center lg:p-8 print-pt-2">
          <div class="w-full flex">
            <div class="w-4 lg:flex items-center justify-center">
              <div class="w-2 h-2 rounded-full bg-teal-500"></div>
            </div>
            <div class="flex-1">
              <div class="font-semibold">
                {{ order.pickupLocation.siteTime | standardDate }}
              </div>
              <div>
                {{ order.pickupLocation.name }}
              </div>
            </div>
          </div>
          <div class="w-full flex mt-2">
            <div class="w-4 lg:flex items-center justify-center">
              <div class="w-2 h-2 rounded-full bg-orange-500"></div>
            </div>
            <div class="flex-1">
              <div class="font-semibold">
                {{ order.dropoffLocation.siteTime | standardDate }}
              </div>
              <div>
                {{ order.dropoffLocation.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div *ngFor="let item of order.lineItems" class="flex flex-col print-flex-row lg:flex-row justify-between">
            <div class="text-gray-600 flex-1 leading-8">
              {{ item.description }}
            </div>
            <div *ngIf="item.totalInPennies < 0; else positive">
              <div class="text-xl font-bold text-red-500 flex-1">-{{ -item.totalInPennies | currencyInPennies }}</div>
            </div>
            <ng-template #positive>
              <div>
                <div class="text-xl font-bold text-gray-800">
                  {{ item.totalInPennies | currencyInPennies }}
                </div>
              </div>
            </ng-template>
          </div>
          <div class="border-b border-gray-400 my-1"></div>
          <div class="flex flex-col print-flex-row lg:flex-row justify-between">
            <div class="text-gray-600 flex-1 leading-8">Load Total</div>
            <div>
              <div class="text-xl font-bold text-green-400 flex-1">
                {{ order.loadTotalInPennies | currencyInPennies }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="statement.dailyJournalEntries?.length">
      <div class="my-2">
        <span class="border-b border-gray-400 mb-2 pr-3 pb-1 text-2xl">Daily Items</span>
      </div>
      <div class="lg:grid grid-cols-6 hidden px-1 font-bold">
        <div>Interval</div>
        <div class="lg:col-span-2">Name</div>
        <div>Driver Name</div>
        <div>Date</div>
        <div class="text-right">Price</div>
      </div>
      <div
        class="grid lg:grid-cols-6 grid-flow-row even:bg-gray-400 p-1"
        *ngFor="let dailyJournal of statement.dailyJournalEntries; trackBy: null | trackByKey"
      >
        <div>
          <span class="font-bold lg:hidden">Interval:&nbsp;</span
          >{{ dailyJournal.billingInterval === 'work_day' ? 'Days Worked' : 'Daily' }}
        </div>
        <div class="lg:col-span-2">
          <span class="font-bold lg:hidden">Name:&nbsp;</span>{{ dailyJournal.displayName }}
        </div>
        <div><span class="font-bold lg:hidden">Driver Name:&nbsp;</span>{{ dailyJournal.driverName }}</div>
        <div><span class="font-bold lg:hidden">Date:&nbsp;</span>{{ dailyJournal | standardDateOnly }}</div>
        <div class="lg:text-right">
          <span class="font-bold lg:hidden">Price:&nbsp;</span>{{ dailyJournal.paidInPennies | currencyInPennies }}
        </div>
      </div>
    </div>
    <div *ngIf="statement.truckJournalEntries?.length">
      <div class="my-2">
        <span class="border-b border-gray-400 mb-2 pr-3 pb-1 text-2xl">Truck Insurance Line Items</span>
      </div>
      <div class="lg:grid grid-cols-6 hidden px-1 font-bold">
        <div class="col-span-2">VIN</div>
        <div>Driver Name</div>
        <div>Date</div>
        <div class="text-right">Insured Value</div>
        <div class="text-right">Price</div>
      </div>
      <div
        class="grid lg:grid-cols-6 grid-flow-row even:bg-gray-400 p-1"
        *ngFor="let truckJournal of statement.truckJournalEntries; trackBy: null | trackByKey"
      >
        <div class="lg:col-span-2"><span class="font-bold lg:hidden">VIN:&nbsp;</span>{{ truckJournal.vin }}</div>
        <div><span class="font-bold lg:hidden">Driver Name:&nbsp;</span>{{ truckJournal.driverName }}</div>
        <div><span class="font-bold lg:hidden">Date:&nbsp;</span>{{ truckJournal | standardDateOnly }}</div>
        <div class="lg:text-right">
          <span class="font-bold lg:hidden">Insured Value:&nbsp;</span
          >{{ truckJournal.valueInPennies | currencyInPennies }}
        </div>
        <div class="lg:text-right">
          <span class="font-bold lg:hidden">Price:&nbsp;</span>{{ truckJournal.paidInPennies | currencyInPennies }}
        </div>
      </div>
    </div>
  </div>
  <div class="flex-1 lg:flex-none lg:w-1/4 lg:border-l border-gray-400 lg:px-2">
    <div class="font-bold text-xl text-gray-800 mb-4">Deductions</div>
    <div *ngFor="let deduction of statement.lineItems; trackBy: 'description' | trackByKey">
      <div class="flex justify-between lg:ml-4 leading-10">
        <div class="text-gray-600">
          {{ deduction.description }}
        </div>
        <div class="text-xl font-bold text-gray-800">
          {{ -deduction.totalInPennies | currencyInPennies }}
        </div>
      </div>
    </div>
    <div class="border-b border-gray-400 my-1"></div>
    <div class="flex justify-between lg:ml-4 leading-10">
      <div class="text-gray-600">Total Deductions</div>
      <div class="text-xl font-bold text-red-500">
        {{ summary.deductionsInPennies | currencyInPennies }}
      </div>
    </div>
    <div class="font-bold text-xl text-gray-800 my-4">Summary</div>
    <div class="flex justify-between lg:ml-4 leading-10">
      <div class="text-gray-600">Daily Revenue</div>
      <div class="text-xl font-bold text-green-400">
        {{ summary.revenueInPennies | currencyInPennies }}
      </div>
    </div>
    <div class="flex justify-between lg:ml-4 leading-10">
      <div class="text-gray-600">Take Rate</div>
      <div class="text-xl font-bold text-gray-800">
        {{ summary.takeRateInPennies | currencyInPennies }}
      </div>
    </div>
    <div class="flex justify-between lg:ml-4 leading-10">
      <div class="text-gray-600">Deductions</div>
      <div class="text-xl font-bold text-red-500">
        {{ summary.deductionsInPennies | currencyInPennies }}
      </div>
    </div>
    <div
      class="flex justify-between lg:ml-4 leading-10"
      *ngFor="let adjustment of statement.adjustment; trackBy: 'id' | trackByKey"
    >
      <div class="text-gray-600">{{ adjustment.userFacingComment }}</div>
      <div
        class="text-xl font-bold"
        [class.text-red-500]="adjustment.totalInPennies < 0"
        [class.text-green-400]="adjustment.totalInPennies > 0"
      >
        {{ adjustment.totalInPennies | currencyInPennies }}
      </div>
    </div>
    <div
      class="flex justify-between lg:ml-4 leading-10"
      *ngFor="let payout of statement.escrowPayouts; trackBy: 'id' | trackByKey"
    >
      <div class="text-gray-600">Deposit Payout</div>
      <div
        class="text-xl font-bold"
        [class.text-red-500]="payout.totalPaid < 0"
        [class.text-green-400]="payout.totalPaid > 0"
      >
        {{ payout.totalPaid | currencyInPennies }}
      </div>
    </div>
    <div class="border-b border-gray-400 my-1"></div>
    <div class="flex justify-between lg:ml-4 leading-10">
      <div class="text-gray-600">Payable</div>
      <div class="text-xl font-bold text-green-400">
        {{ summary.payableInPennies | currencyInPennies }}
      </div>
    </div>
  </div>
</div>
